/**
 * Collection page — sort select navigation.
 */

/**
 * @param {HTMLElement} section
 */
function initCollectionSection(section) {
  const abortController = new AbortController();
  const { signal } = abortController;

  section.querySelectorAll('.collection-sort__select').forEach((select) => {
    select.addEventListener(
      'change',
      (event) => {
        const target = event.target;
        if (!(target instanceof HTMLSelectElement)) {
          return;
        }

        const params = new URLSearchParams(window.location.search);

        if (target.value) {
          params.set('sort_by', target.value);
        } else {
          params.delete('sort_by');
        }

        params.delete('page');

        const nextQuery = params.toString();
        window.location.search = nextQuery
          ? `?${nextQuery}`
          : window.location.pathname;
      },
      { signal }
    );
  });

  section.dataset.collectionBound = 'true';
}

document.querySelectorAll('[data-collection]').forEach((section) => {
  if (!(section instanceof HTMLElement)) {
    return;
  }

  if (section.dataset.collectionBound === 'true') {
    return;
  }

  initCollectionSection(section);
});
